import { render, staticRenderFns } from "./IconFacebook.vue?vue&type=template&id=755ca28c"
import script from "./IconFacebook.vue?vue&type=script&lang=js"
export * from "./IconFacebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports